document.addEventListener('DOMContentLoaded', function () {

  var list = document.querySelector(
    '#ACC_YGH_LP_03_13 .ACC_YGH_LP_03_13_list'
  );

  if (!list) return;

  list.addEventListener('click', function (event) {

    var trigger = event.target.closest(
      '.ACC_YGH_LP_03_13_trigger'
    );

    if (!trigger || !list.contains(trigger)) return;

    var item = trigger.closest(
      '.ACC_YGH_LP_03_13_item'
    );

    if (!item) return;

    var opening = !item.classList.contains('is-open');

    list
      .querySelectorAll('.ACC_YGH_LP_03_13_item.is-open')
      .forEach(function (openItem) {

        openItem.classList.remove('is-open');

        var openTrigger = openItem.querySelector(
          '.ACC_YGH_LP_03_13_trigger'
        );

        if (openTrigger) {
          openTrigger.setAttribute('aria-expanded', 'false');
        }

      });

    if (opening) {

      item.classList.add('is-open');

      trigger.setAttribute('aria-expanded', 'true');

    }

  });

});